import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 29.333c1.467 0 2.667-1.2 2.667-2.667h-5.333c0 1.467 1.187 2.667 2.667 2.667zM24 21.333v-6.667c0-4.093-2.187-7.52-6-8.427v-0.907c0-1.107-0.893-2-2-2s-2 0.893-2 2v0.907c-3.827 0.907-6 4.32-6 8.427v6.667l-1.72 1.72c-0.84 0.84-0.253 2.28 0.933 2.28h17.56c1.187 0 1.787-1.44 0.947-2.28l-1.72-1.72z" })
});
export default SvgNotifications;
